// eslint-disable-next-line
import { GetWeatherStations, GetSensorStatus } from '@/api/api';
import { Mixin } from 'gw-js-lib';

export default {
  namespaced: true,
  state: { /* = data */
    stations: [],
    sensorStatus: [],
    sensorStatusFilter: null,
    rssiRanges: [],
    loading: {
      stations: false,
      stationStatus: false,
      global: false,
    },
  },

  actions: { /* = Methods */
    async loadStations({ commit, state }, hideLoading) {
      if (Mixin.methods.G_isEmptyArr(state.stations) && !hideLoading) {
        commit('setLoading', { ...state.loading, sensors: true });
      }

      await GetWeatherStations().then((response) => {
        commit('setStations', response);
        commit('setLoading', { ...state.loading, stations: false });
      }).catch(() => {
        commit('setLoading', { ...state.loading, stations: false });
      });
    },

    async loadSensorStatus({ commit, state }) {
      if (Mixin.methods.G_isEmptyArr(state.sensorStatus)) {
        commit('setLoading', { ...state.loading, sensorStatus: true });
      }
      GetSensorStatus().then((sensorStatus) => {
        commit('setLoading', { ...state.loading, sensorStatus: false });
        commit('setSensorStatus', sensorStatus);
      }).catch(() => {
        commit('setLoading', { ...state.loading, sensorStatus: false });
      });
    },

    GetRssiIcon({ state }, sensor) {
      const iconRssi = Mixin.methods.G_getRssiIcon(sensor, state.rssiRanges);
      // eslint-disable-next-line
      return require(`@/assets/img/gw/sensor/${iconRssi}`);
    },
  },

  mutations: { /* Mutations are responsible to change the state */
    setStations(state, stations) {
      state.stations = stations;
    },
    setSensorStatusFilter(state, sensorStatusFilter) {
      state.sensorStatusFilter = sensorStatusFilter;
    },
    setSensorStatus(state, sensorStatus) {
      state.sensorStatus = sensorStatus;
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    updateSensor(state, cleanSensor){
      let tempIndex = state.sensors.findIndex( sensor => sensor.sensor_id === cleanSensor.sensor_id );
      state.sensors[tempIndex] = { ...state.sensors[tempIndex], ...cleanSensor };
    },

  },

};
